<script>
import { Bar } from 'vue-chartjs';
import LocalizationMixin from '@/mixins/localization-mixin';

export default {
  extends: Bar,
  props: {
    mixins: [LocalizationMixin],
    labels: {
      type: Array,
      default: () => {
        return [];
      },
    },
    data: {
      type: Object,
      default: () => {},
    },
    tooltips: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      chartdata: {
        labels: this.labels,
        datasets: [
          {
            label: this.$t('currentYear2'),
            backgroundColor: '#014C70',
            data: this.data.currentYear,
            tooltips: this.tooltips.currentYear,
            categoryPercentage: 0.5,
            order: 1,
          },
          {
            label: this.$t('previousYear'),
            backgroundColor: '#0399E4',
            data: this.data.lastYear,
            tooltips: this.tooltips.lastYear,
            categoryPercentage: 0.5,
            order: 1,
          },
        ],
      },
      options: {
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              label +=
                data.datasets[tooltipItem.datasetIndex].tooltips[
                  tooltipItem.index
                ];
              return label;
            },
          },
        },
        maintainAspectRatio: false,
      },
    };
  },

  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>
